var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreyAddTagIcon = function SvgGreyAddTagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C95A8",
    d: "M6.042 5.466a.867.867 0 0 1 0 1.732.867.867 0 0 1 0-1.732m7.45-1.087V11.9c0 .45-.363.813-.813.813h-2.597v.474c0 .45-.363.813-.813.813H2.812A.81.81 0 0 1 2 13.187v-7.52c0-.221.091-.434.251-.587l2.303-2.206a2.1 2.1 0 0 1 1.488-.587c.348 0 .673.074.962.219l.958-.92A2.12 2.12 0 0 1 9.452 1c.574 0 1.087.203 1.488.587l2.303 2.206a.8.8 0 0 1 .249.586M8.459 6.012 6.408 4.044a.5.5 0 0 0-.363-.134.48.48 0 0 0-.363.134L3.63 6.012v6.363h4.832zm3.408-1.285L9.815 2.76a.5.5 0 0 0-.363-.135.48.48 0 0 0-.363.135l-.838.804 1.582 1.519c.16.152.251.365.251.586v5.424h1.785z"
  })));
};
export default SvgGreyAddTagIcon;